import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { makeStyles } from '@material-ui/styles';
import styles from './ImageModal.styles';
import { Button } from '@material-ui/core';

const useStyles = makeStyles(styles);

const ImageModal = ({ image, open, onClose, canEdit = false }) => {
  const [rotateAngle, setRotateAngle] = useState(0);
  const [zoomViewHeight, setZoomViewHeight] = useState(75);
  const classes = useStyles();
  const handleRotate = () => {
    setRotateAngle(rotateAngle + 90);
  }
  const handleZoomIn = () => {
    setZoomViewHeight(zoomViewHeight + 5);
  }

  const handleZoomOut = () => {
    setZoomViewHeight(zoomViewHeight - 5);
  }

  return (
    <Dialog
      open={open}
      maxWidth="lg"
      onClose={onClose}
      aria-labelledby="image-modal-title"
      className={classes.imageModal}
      autoScrollBodyContent={false}
      contentStyle={{ width: '100%', maxWidth: 'none' }}
    >
      <DialogContent className="col-center-center">
        <div style={{ maxHeight: "75vh", overflow: "scroll" }}>
          <img className={classes.image} style={{ transform: `rotate(${rotateAngle}deg)`, maxHeight: `${zoomViewHeight}vh` }} {...image} alt="Missing" />
        </div>
        <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
          <Button
            className="blue-button"
            style={{
              marginTop: 10,
              marginBottom: 5,
            }}
            onClick={onClose}
          >
            Close
          </Button>
          {canEdit && (
            <>
              <Button
                className="blue-button"
                style={{
                  marginTop: 10,
                  marginBottom: 5,
                  marginLeft: 10,
                }}
                onClick={handleRotate}
              >
                Rotate
              </Button>
              <Button
                disabled={zoomViewHeight === 75}
                className={zoomViewHeight === 75 ? "gray-button" : "blue-button"}
                style={{
                  marginTop: 10,
                  marginBottom: 5,
                  marginLeft: 10,
                }}
                onClick={handleZoomOut}
              >
                Zoom Out
              </Button>
              <Button
                className="blue-button"
                style={{
                  marginTop: 10,
                  marginBottom: 5,
                  marginLeft: 10,
                }}
                onClick={handleZoomIn}
              >
                Zoom In
              </Button>
            </>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
ImageModal.defaultProps = {};
ImageModal.propTypes = {
  image: PropTypes.object,
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

export default ImageModal;
